import React, {useEffect, useMemo, useRef, useState} from "react";
import * as Yup from "yup";
import ValidateMessages from "../../../../../../core/models/static/texts/vallidate-messages";
import {makeRequired, makeValidate} from "mui-rff";
import useIsMounted from "../../../../../hooks/use-is-mounted";
import Api from "../../../../../../core/services/api/api";
import Form from "../../../../base/form";
import {OutlinedDropdownForm} from "../../../../base/dropdown/outlined_dropdown";
import Button from "../../../../base/button/button";


const formNames = {
    country: 'addCountry_country',
}

const schema = Yup.object().shape({
    [formNames.country]: Yup.object().nullable().required(ValidateMessages.required),
});

const validate = makeValidate(schema);
const required = makeRequired(schema);


const UpsertFreightRegionDialogAddCountrySection = ({addCountry, selectedCountries}) => {
    const [countries, setCountries] = useState([]);
    const isMounted = useIsMounted();
    /**@type {React.MutableRefObject<formApi>}*/
    const formRef = useRef();

    const visibleCountries = useMemo(() => {
        const selectedIds = selectedCountries.map(e => e.id);
        return countries.filter(e => !selectedIds.includes(e.id));
    }, [countries, selectedCountries])

    const initialValues = useMemo(() => ({
        [formNames.country]: null,
    }), [])

    /**
     * As soon as the component is mounted:
     * - fetches all the countries from the server
     */
    useEffect(() => {
        getAllCountries().then();
    }, []);

    /**
     * Fetches all the countries from the server.
     * @return {Promise<void>}
     */
    const getAllCountries = async () => {
        const response = await Api.getAllCountries();
        if (!isMounted())
            return;
        if (response?.resultFlag) {
            setCountries(response.data);
        }
    }

    /**
     * Submits the form by calling the appropriate callback with the country value and then removes the value from the fields.
     * @param values
     * @return {Promise<void>}
     */
    const onSubmit = async (values) => {
        addCountry(values[formNames.country]);
        setTimeout(() => {
            formRef.current?.change(formNames.country, initialValues[formNames.country]);
            formRef.current?.resetFieldState(formNames.country);
        }, 300);
    }

    return (
        <>
            <Form
                className={'d-flex flex-wrap w-100'}
                onSubmit={onSubmit}
                validate={validate}
                initialValues={initialValues}
                render={({form}) => {
                    formRef.current = form
                    return (
                        <div className={'w-100 d-flex align-items-center'}>
                            <OutlinedDropdownForm
                                name={formNames.country}
                                label={"Country"}
                                required={!!required[formNames.country]}
                                data={visibleCountries?.map(e => ({
                                    id: e.id,
                                    label: e.name,
                                    value: e,
                                }))}
                            />
                            <Button
                                variant={'contained'}
                                color={'primary'}
                                type={'button'}
                                className={'ml-3 px-5 py-2-5'}
                                onClick={() => formRef.current.submit()}
                            >
                                Add
                            </Button>
                        </div>
                    );
                }}
            />
        </>
    );
}

export default UpsertFreightRegionDialogAddCountrySection;
